import { useQuery, QueryObserverOptions } from "@tanstack/react-query";
import type { Organisation } from "@models/Organisation";
import { apiGet } from "../client";
import { useLoggedInUser } from "./useAuth";

interface CommonQueryOptions {
	keepPreviousData?: QueryObserverOptions["keepPreviousData"];
	onSuccess?: QueryObserverOptions["onSuccess"];
	refetchOnWindowFocus?: boolean;
}

/**
 * Hook to get the organisation for the logged-in user
 */
export function useOrganisation(onError?: (errorCode: string) => void, opts?: CommonQueryOptions) {
	const user = useLoggedInUser();

	const { data, ...rest} = useQuery<Organisation>({
		queryKey: ["organisation"],
		queryFn: () => apiGet<Organisation>(`/organisation/${user.profile.organisation.id}`),
		staleTime: 5 * 60 * 1000, // okay to see 5 min old organisation
		...opts,
		onError: (error: any) => {
			const errorCode = error?.response?.data?.code || error?.message || "UNKNOWN_ERROR";
			if (onError) {
				onError(errorCode);
			}
		},
	});

	return {
		organisation: data,
		...rest,
	};
}
